import { Route, Switch } from 'react-router-dom';
// @ts-expect-error not typed
import UniversalApplicationContainer from 'ContentEditorUI/containers/UniversalApplicationContainer';
// @ts-expect-error not typed
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
// @ts-expect-error not typed
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getIsUngatedForRevisionHistory } from 'case-study-lib/utils/auth';
import ContentViewContainer from '../editor/components/ContentViewContainer';
import { GatedRoute } from './GatedRoute';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncRevisionHistoryContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'AsyncRevisionHistoryContainer' */'case-study-editor-ui/editor/components/RevisionHistoryContainer'));
const basePath = '/:instanceId';
const concatPaths = path => `${basePath}/${path}`;
const Routes = () => {
  return /*#__PURE__*/_jsx(Route, {
    path: basePath,
    children: /*#__PURE__*/_jsx(UniversalApplicationContainer, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: concatPaths('content'),
          exact: true,
          children: /*#__PURE__*/_jsx(ContentViewContainer, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: concatPaths('preview'),
          exact: true,
          children: /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
            children: ({
              PreviewModal
            }) => /*#__PURE__*/_jsx(PreviewModal, {})
          })
        }), /*#__PURE__*/_jsx(GatedRoute, {
          path: concatPaths('revisions'),
          redirectPath: "content",
          isUngated: getIsUngatedForRevisionHistory(),
          children: /*#__PURE__*/_jsx(AsyncRevisionHistoryContainer, {})
        })]
      })
    })
  });
};
export default Routes;